import { render, staticRenderFns } from "./Debug.vue?vue&type=template&id=44f71647&scoped=true"
import script from "./Debug.vue?vue&type=script&lang=js"
export * from "./Debug.vue?vue&type=script&lang=js"
import style0 from "./Debug.vue?vue&type=style&index=0&id=44f71647&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f71647",
  null
  
)

export default component.exports